/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Fan_WeeksInputs */

const en_us2_wrapped_fan_weeks = /** @type {(inputs: Wrapped_Fan_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wk`)
};

const pt_br2_wrapped_fan_weeks = /** @type {(inputs: Wrapped_Fan_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sem.`)
};

const es_419_wrapped_fan_weeks = /** @type {(inputs: Wrapped_Fan_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sem.`)
};

const pt_pt2_wrapped_fan_weeks = /** @type {(inputs: Wrapped_Fan_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sem.`)
};

const fr_fr2_wrapped_fan_weeks = /** @type {(inputs: Wrapped_Fan_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sem.`)
};

const de_de2_wrapped_fan_weeks = /** @type {(inputs: Wrapped_Fan_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo.`)
};

const it_it2_wrapped_fan_weeks = /** @type {(inputs: Wrapped_Fan_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sett.`)
};

/**
* | output |
* | --- |
* | "wk" |
*
* @param {Wrapped_Fan_WeeksInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_fan_weeks = /** @type {((inputs?: Wrapped_Fan_WeeksInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Fan_WeeksInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_fan_weeks(inputs)
	if (locale === "es-419") return es_419_wrapped_fan_weeks(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_fan_weeks(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_fan_weeks(inputs)
	if (locale === "de-DE") return de_de2_wrapped_fan_weeks(inputs)
	if (locale === "it-IT") return it_it2_wrapped_fan_weeks(inputs)
	return en_us2_wrapped_fan_weeks(inputs)
});
export { wrapped_fan_weeks as "wrapped.fan_weeks" }